<mad-button-group>
  <button mat-stroked-button madButton>Group 1</button>
  <button mat-stroked-button madButton>Group 2</button>
  <button mat-stroked-button madButton>Group 3</button>
</mad-button-group>
<br /><br />
<mad-button-group>
  <button mat-raised-button madButton>Group 4</button>
  <button mat-raised-button madButton>Group 5</button>
  <button mat-raised-button madButton>Group 6</button>
</mad-button-group>
